<template>
  <div
    class="flex items-center gap-2 border-1 rounded-md p-2 cursor-pointer"
    :class="{
      'bg-primary-50 border-primary-600 hover:border-primary-600': isSelected,
      'bg-white border-secondary-400 hover:border-secondary-600': !isSelected,
    }"
    @click="emit('click')"
  >
    <div
      class="flex flex-row items-center w-[30px] h-[38px] bg-white border-1 border-secondary-300 shadow-sm rounded-md shrink-0"
    >
      <img
        v-if="displayedMimeType.startsWith('image/') && thumbnailUrl"
        :src="thumbnailUrl"
        :alt="t('common.file.previewAlt')"
        class="w-full h-full object-cover rounded-md"
      />
      <AwIcon v-else name="i-ph-file" class="m-auto text-secondary-600" />
    </div>

    <span class="text-md font-semibold truncate">{{ displayedName }}</span>

    <div v-if="$slots.actions || isRemovable" class="ml-auto flex items-center gap-2">
      <slot name="actions"></slot>
      <AwButton
        v-if="isRemovable"
        leading-icon="i-ph-trash"
        size="sm"
        color="secondary"
        variant="outline"
        @click.stop="emit('onRemove')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /** A file picked in the browser. For a stored file, pass `name`, `mimeType` and `thumbnailSrc` instead. */
  file?: File;
  name?: string;
  mimeType?: string;
  thumbnailSrc?: string;
  isSelected: boolean;
  isRemovable?: boolean;
}

interface Emits {
  click: [];
  onRemove: [];
}

const { t } = useI18n();
const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const displayedName = computed(() => props.file?.name ?? props.name ?? "");
const displayedMimeType = computed(() => props.file?.type ?? props.mimeType ?? "");
const thumbnailUrl = computed(
  () => props.thumbnailSrc ?? (props.file ? window.URL.createObjectURL(props.file) : undefined)
);
</script>
